export default __webpack_public_path__ + "static/media/logo_lyria.b134fee1.svg";